/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import DialogInformation from "./Components/DialogInformation";
import NoneData from "components/NoneData";
import useStyles from "./styles";
import CardGiftItem from "./Components/CardGiftItem";

import {
	getGiftExchangePointAction,
	createOrderExchangePointAction
} from "store/actions/GiftExchangePageAction";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { Images } from "config/images";
import { formatCash } from "config/constant";

const GiftExchangePage = props => {
	const {
		getGiftExchangePoint,
		createOrderExchangePoint,
		giftExchangePoint,
		infoShop
	} = props;
	const history = useHistory();
	const business = infoShop?.business || "THOPHAT";

	const classes = useStyles();
	const [isOpen, setOpen] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);
	const [message, setMessage] = useState("");
	const [dataChangeGift, setDataChangeGift] = useState({});
	const idNotification = new URLSearchParams(history.location.search).get(
		"id"
	);

	useEffect(() => {
		const data = {
			business: business,
			loyaltyId: idNotification
		};
		getGiftExchangePoint(data);
	}, []);

	const handleConfirmChangeGift = value => {
		const data = {
			shopId: value.shopId,
			level: value.level,
			business: business,
			loyaltyId: value.loyaltyId,
			items: value?.items?.filter(item => item?.quantity !== 0) //lọc tất cả các sản phẩm gửi lên có số lượng là 0
		};

		setDataChangeGift(data);

		const onSuccess = () => {
			const data = {
				business: business,
				loyaltyId: idNotification
			};
			getGiftExchangePoint(data);
			setOpen(true);
			setIsSuccess(true);
		};

		const onError = message => {
			setOpen(true);
			setIsSuccess(false);
			setMessage(message);
		};

		const params = {
			data,
			onSuccess,
			onError
		};
		createOrderExchangePoint(params);
	};

	const handleClose = () => {
		setOpen(false);
		setTimeout(() => {
			setIsSuccess(false);
			setMessage("");
		}, 200);
	};

	const handleSubmit = value => {
		if (value) {
			handleClose();
		} else {
			handleConfirmChangeGift(dataChangeGift);
		}
	};

	return (
		<React.Fragment>
			<Grid classes={{ root: classes.rootHeader }}>
				<Grid classes={{ root: classes.header }}>
					<Grid
						classes={{ root: classes.btnBack }}
						onClick={() => {
							history.goBack();
						}}
					>
						<ArrowBackIcon />
					</Grid>
					<Grid classes={{ root: classes.title }}>
						Đổi điểm nhận quà
					</Grid>
				</Grid>
				<Grid style={{ padding: "15px 20px 0px" }}>
					<Grid classes={{ root: classes.rootPoint }}>
						<Grid classes={{ root: classes.bgPoint }}>
							<Grid classes={{ root: classes.point }}>
								<Grid classes={{ root: classes.titlePoint }}>
									Tổng điểm hiện tại
								</Grid>
								<Grid classes={{ root: classes.price }}>
									<img src={Images.icDollar} alt="icDollar" />{" "}
									{formatCash(giftExchangePoint?.pointShop) ||
										0}{" "}
									điểm
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid classes={{ root: classes.gift }}>
				<Grid style={{ padding: 16 }}>
					{giftExchangePoint?.rewardGifts?.length > 0 ? (
						giftExchangePoint?.rewardGifts?.map((gift, index) => (
							<CardGiftItem
								key={index}
								pointShop={giftExchangePoint?.pointShop}
								shopId={giftExchangePoint?.shopId}
								loyaltyId={giftExchangePoint?.loyaltyId}
								isVoucher={
									gift.awardForm === "TRADE_DISCOUNTS"
										? true
										: false
								}
								gift={gift}
								handleConfirmChangeGift={
									handleConfirmChangeGift
								}
							/>
						))
					) : (
						<NoneData />
					)}
				</Grid>
			</Grid>
			<DialogInformation
				open={isOpen}
				isSuccess={isSuccess}
				message={message}
				handleClose={handleClose}
				handleSubmit={handleSubmit}
			/>
		</React.Fragment>
	);
};

const mapStateToProps = state => {
	return {
		giftExchangePoint: state.giftExchangePageReducer.giftExchangePoint,
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getGiftExchangePoint: data => {
			dispatch(getGiftExchangePointAction(data));
		},
		createOrderExchangePoint: data => {
			dispatch(createOrderExchangePointAction(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(GiftExchangePage);
